
const initialState = {
    user: null
}

export default {
    authen: (state = initialState, action) => {
        switch (action.type) {
            default:
                return {
                    ...state,
                }
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerAuth.js